import React from "react";
import styles from "./Mission.module.css";
import missionImage1 from "../../../assets/images/about-mission1.png";
import missionImage2 from "../../../assets/images/about-mission2.png";
import missionImage3 from "../../../assets/images/about-mission3.png";
import aboutValues from "../../../assets/images/about-values.png";
import { Animate, Stagger } from "../../animations";

const cards = [
  {
    image: missionImage1,
    title: "Our Mission",
    text: "To empower Indian students with the knowledge, resources, and support they need to access world-class education abroad — making global opportunities accessible to every deserving student.",
  },
  {
    image: missionImage2,
    title: "Our Vision",
    text: "To become India's most trusted study-abroad consultancy, recognized for integrity, transparency, and a track record of transforming lives through international education.",
  },
  {
    image: missionImage3,
    title: "Our Purpose",
    text: "We exist to bridge the gap between ambition and achievement. Every student deserves expert guidance, fair pricing, and a partner who genuinely cares about their success abroad.",
  },
];

const Mission = () => {
  return (
    <>
      <Stagger className={styles.missionContainer} variant="fadeUp" stagger={140}>
        {cards.map((card) => (
          <div key={card.title} className={`${styles.missionCard} anim-hover-lift`}>
            <img src={card.image} alt={card.title} className={styles.missionImage} />
            <h2 id="heading-md">{card.title}</h2>
            <p>{card.text}</p>
          </div>
        ))}
      </Stagger>
      <Animate variant="zoomIn" delay={100}>
        <div className={styles.aboutValues}>
          <img src={aboutValues} alt="Our core values" />
        </div>
      </Animate>
    </>
  );
};

export default Mission;
